module.exports = __webpack_public_path__ + "43359a607de761b6bf83ed815d554cc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/SchoolCamps/camps2.jpg
// module id = 1225
// module chunks = 0